<template>
    <b-card class="block__objectiveListBonus">
      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>          
            {{title}}
          </PuSkeleton>
        </p>
        <p class="number">
          <PuSkeleton :loading="isLoading" width="20px">          
            {{objectifNumber}}
          </PuSkeleton>
        </p>
      </header>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of this.datalists" :key="index">
          <div class="entete">
            <div class="left">
                <PuSkeleton :loading="isLoading" :count="1" width='160px'>          
                  <div v-if="list.name" class="title">{{list.name}}</div>
                  <div v-if="list.target && list.target === 'progress'" class="target green">En cours</div>
                  <div v-if="list.target && list.target === 'done'" class="target done">Terminé</div>
                </PuSkeleton>
            </div>
            <div v-if="list.value" class="number">
              <PuSkeleton :loading="isLoading" width="20px">
                {{Math.round(Math.floor(list.value)).toLocaleString()}}
              </PuSkeleton>
            </div>
          </div>
          <div v-if="list.startDate && list.endDate" class="label">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>            
              Du {{ list.startDate | moment(false) }} au {{ list.endDate | moment(true) }} 
            </PuSkeleton>
          </div>
          <div v-if="list.subtitle" class="subLabel">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>            
              {{list.subtitle}}
            </PuSkeleton>
          </div>
        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
moment.locale('fr');

export default {
name:"wrapperObjectiveListBonus",
  props:{
    objectifNumber:{
      type:Number,
      default:null
      },
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },      
    lists:{
      type:[Array],
      },
    isLoad:{
      default: true
    },       
  },
  data(){
    return {
      isLoading:true,
      title: 'Bonus excursion',
      general:'',
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
  },
  methods:{
    moment: function (date,year) {
      return moment(date,year);
    },     
  },
  filters: {
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do MMMM YYYY';
      return moment(date).format($format);
    }
  },   
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;  
      this.isLoading = this.isLoad;
    },    
  },    
}
</script>
